import DatePicker, { DateObject } from 'react-multi-date-picker'
import { Grid } from '@mui/material'
import DateRangeIcon from '@mui/icons-material/DateRange'

import AutoComplete from '../components/AutoComplete'
import { colours, WEEK_DAYS, MONTHS } from '../settings/settings'
import { fromDateToString } from '../hooks/utils-functions'

const MyDatesPicker = ({
  id,
  label,
  value,
  onChange,
  onInputChange,
  minDate,
  maxDate,
  onlyDays,
  mode,
  isMobile,
  disabled,
  readOnly,
}) => {
  const mapDays = x => {
    if (onlyDays?.length && !onlyDays.includes(x?.date?.weekDay?.index))
      return { disabled: true, style: { color: colours.greyVeryLight } }
  }

  return (
    <Grid container size={12} alignItems='center' sx={{ width: '100%' }}>
      <Grid size={{ xs: 10, md: 11 }}>
        <AutoComplete
          id={id}
          label={label}
          value={value}
          options={[]}
          onChange={onChange}
          onInputChange={(_, __, reason) => {
            if (reason === 'input') onInputChange()
          }}
          getOptionLabel={op => fromDateToString(op)}
          multiple={true}
          openable={false}
          optional={true}
          readOnly={!!readOnly}
          showPopupIcon={false}
          mode={mode}
        />
      </Grid>
      <Grid size={{ xs: 2, md: 1 }} sx={{ cursor: 'pointer' }}>
        <center>
          <DatePicker
            id={id}
            value={value}
            onChange={onChange}
            disabled={!!disabled}
            disableYearPicker={true}
            disableMonthPicker={true}
            fullYear={false}
            hideOnScroll={true}
            highlightToday={false}
            multiple={true}
            readOnly={!!readOnly}
            showOtherDays={true}
            sort={true}
            calendarPosition='left'
            format='DD/MM/YYYY'
            numberOfMonths={1}
            weekStartDayIndex={1}
            months={MONTHS}
            weekDays={WEEK_DAYS}
            minDate={minDate}
            maxDate={maxDate}
            currentDate={new DateObject()}
            className={isMobile && 'rmdp-mobile'}
            mobileLabels={{ OK: 'OK', CANCEL: 'ANNULLA' }}
            render={(_, openCalendar) => (
              <DateRangeIcon onClick={openCalendar} />
            )}
            mapDays={mapDays}
          />
        </center>
      </Grid>
    </Grid>
  )
}

export default MyDatesPicker
